import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { FormControl, InputLabel, Select, MenuItem, Button } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import styled from 'styled-components';

import DynamicDialog from '../../DynamicDialog/DynamicDialog';
import { AddProceedCancelDialogButtons } from '../../BranchDetails/components/BranchComponents';

const EditableSelect = props => {
  const [editEnabled, setEditEnabled] = useState(false);
  const [selectValue, setSelectValue] = useState(props.value);
  const [alertDialog, setAlertDialog] = useState(false);

  const { fetching } = useSelector(state => state.surgeries);

  const { value, label } = props;

  useEffect(() => {
    setSelectValue(props.value);
  }, [props]);

  function resetValue() {
    setEditEnabled(false);
    setSelectValue(value);
    setAlertDialog(false);
  }

  function handleChange(e) {
    setSelectValue(e.target.value);
    if (e.target.value !== value) setAlertDialog(true);
  }

  function updateValue() {
    props.handleChange(selectValue);
    resetValue();
  }

  function stopEditing() {
    resetValue();
  }

  return editEnabled
    ? (
      <Container>
        <DynamicDialog
        open={alertDialog} title={'Change GPSoC prvider'}
        contentText={`Changing GP system will unlink all existing GPSoC patients`}
        actions={AddProceedCancelDialogButtons(() => setAlertDialog(false), () => resetValue())}
      />
        <StyledFormControl>
          <InputLabel id={`label-${label}`}>{ label }</InputLabel>
          <Select
            labelid={`label-${label}`}
            value={selectValue.toLowerCase()}
            label={label}
            onChange={handleChange}
          >
            {props.options.map(option => <MenuItem key={option} value={option}>{ option.toUpperCase() }</MenuItem>)}
          </Select>
        </StyledFormControl>
        {selectValue !== value && <Button color="primary" variant="outlined" onClick={updateValue}>Update</Button>}
        <Button color="secondary" variant="outlined" onClick={stopEditing}>Close</Button>
      </Container>
    )
    : (<p>
      <span>{ value.toUpperCase() }</span>
      <EditButton onClick={setEditEnabled.bind(this, true)} disabled={fetching}>
        { fetching ? 'Updating...' : 'Edit' }
      </EditButton>
    </p>)
};

export default EditableSelect;

const StyledFormControl = withStyles({
  root: {
    minWidth: '160px'
  }
})(FormControl);

const Container = styled.div`
  display: flex;
  gap: 10px;
`;

const EditButton = styled.button`
  border: 0;
  background-color: transparent;
  color: #2f9d6d;
  margin-left: 20px;
  cursor: pointer;
`;
